"use client";

import { isChunkLoadError, reloadOnceForChunkError } from "@/lib/chunk-error";
import * as Sentry from "@sentry/nextjs";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    const t = useTranslations("common");
    useEffect(() => {
        // Stale chunk after a deploy: recover with a one-time reload instead of
        // showing the error page (and don't add to the Sentry noise for it).
        if (isChunkLoadError(error) && reloadOnceForChunkError()) {
            return;
        }
        // Log the error to Sentry
        Sentry.captureException(error);
    }, [error]);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center p-4">
            <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-lg">
                <h2 className="mb-4 text-2xl font-bold text-red-600">
                    {t("errorTitle")}
                </h2>
                <p className="mb-4 text-gray-600">{t("errorBody")}</p>
                <button
                    onClick={reset}
                    className="w-full rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
                >
                    Tekrar Dene
                </button>
            </div>
        </div>
    );
}
